/* global Swiper, getChildElementIndex */
// *******************************************************************************
// 1.0 - count block slider
// *******************************************************************************

const scheduleTabSliderElements = document.querySelectorAll('[data-slider="schedule-tab__nav"]');

const scheduleTabSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 20,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    1200: {
      spaceBetween: 30,
    },
  },
};

scheduleTabSliderElements.forEach((el) => {
  const scheduleTabSliderParent = el.closest('.schedule-tab');
  const arrowRight = scheduleTabSliderParent.querySelector('.arrow-right');
  const arrowLeft = scheduleTabSliderParent.querySelector('.arrow-left');

  scheduleTabSliderOptions.navigation.nextEl = arrowRight;
  scheduleTabSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-unused-vars
  const scheduleTabSlider = new Swiper(el, scheduleTabSliderOptions);
});

// *******************************************************************************
// 2.0 - Tabs
// *******************************************************************************

window.addEventListener('load', () => {
  const navTabLink = document.querySelectorAll('.schedule-tab__nav-link ');

  // Close tab content
  const closeTabContents = (tabNavParent) => {
    const tabContentElems = tabNavParent.querySelectorAll('.schedule-tab__content');
    navTabLink.forEach((elem) => {
      elem.classList.remove('is-active');
    });
    tabContentElems.forEach((contentElem) => {
      contentElem.classList.remove('is-active');
    });
  };

  // Open specific tab
  navTabLink.forEach((el) => {
    el.addEventListener('click', () => {
      const tabNavParent = el.closest('.schedule-tab');
      const parentSlide = el.closest('.swiper-slide');
      const targetTabContent = tabNavParent.querySelectorAll('.schedule-tab__content')[getChildElementIndex(parentSlide)];
      closeTabContents(tabNavParent);
      targetTabContent.classList.add('is-active');
      el.classList.add('is-active');
    });
  });
});
